import React from "react";
import { processStatisticsPercentage, renderStatistics } from "@/modules/statistics";
import { IGameStatisticsClass } from "@/types/StatisticsTypes";

export default class M39 extends IGameStatisticsClass {
	constructor() {
		super(null);

		this.filtrate = function(history, filter) {
			const total = history.length;

			let reds = 0, ties = 0, blues = 0;

			for (const item of history) {
				const [ red, blue ] = item.angka.match(/\d+/g).map(num => Number(num));

				if (red === blue)
					ties++;
				else if (red > blue)
					reds++;
				else blues++;
			}

			this.statisticsArray.top.push([
				<div key="m39_gst_0" className="sl-roadmap-circle red-bg"></div>,
				<div key="m39_gst_1" className="sl-roadmap-circle green-bg"></div>,
				<div key="m39_gst_2" className="sl-roadmap-circle blue-bg"></div>
			]);

			this.statisticsArray.bottom.push([
				processStatisticsPercentage("m39_gst_0", reds, total),
				processStatisticsPercentage("m39_gst_1", ties, total),
				processStatisticsPercentage("m39_gst_2", blues, total),
			])
		}
	}

	render() {
		return renderStatistics(this);
	}
}